export const getSunday = (number = 1, now) => {
	let comingSunday = new Date(now);
	comingSunday.setDate(comingSunday.getDate() + (7 - comingSunday.getDay()) % 7 - 7 * number);
	comingSunday.setHours(23, 59, 59, 59);
	return comingSunday;
};
